export const translations = {
  es: {
    nav: { feed: 'Descubrir', map: 'Mapa', playlists: 'Playlists', support: 'Soporte', profile: 'Perfil' },
    home: {
      hero_title: 'La musica primero, la escena despues',
      hero_subtitle: 'Descubre artistas, guarda favoritos, sigue eventos y contrata solo cuando tenga sentido',
      cta: 'Ver perfil',
      trending: 'Trending',
      top_local: 'Top Local',
      for_you: 'Para Ti',
      featured_artists: 'Artistas Destacados',
      upcoming_events: 'Proximos Eventos',
      discover: 'Descubrir',
      view_all: 'Ver Todo',
      likes: 'Corcheas',
      plays: 'Plays',
      available: 'Disponible',
      not_available: 'No Disponible',
    },
    artist: {
      per_show: '/ Show',
      upcoming: 'Proximos Eventos',
      songs: 'Canciones',
      similar: 'Artistas Similares',
      hire: 'Contratar',
      followers: 'Fans',
      reviews: 'Resenas',
    },
    events: {
      title: 'Mapa de Eventos',
      filter_genre: 'Genero',
      filter_city: 'Ciudad',
      filter_date: 'Fecha',
      view_artists: 'Ver Artistas',
      view_today: 'Ver Eventos Hoy',
      capacity: 'Capacidad',
      price: 'Precio',
    },
    player: {
      queue: 'Cola de Reproduccion',
      history: 'Historial',
      shuffle: 'Aleatorio',
      repeat: 'Repetir',
      now_playing: 'Reproduciendo',
    },
    playlist: {
      title: 'Mis Playlists',
      create: 'Crear Playlist',
      add_song: 'Anadir Cancion',
      empty: 'Sin canciones aun',
      public: 'Publica',
      private: 'Privada',
      name: 'Nombre',
      description: 'Descripcion',
    },
    booking: {
      title: 'Contratacion',
      event_type: 'Tipo de Evento',
      date: 'Fecha',
      location: 'Ubicacion',
      message: 'Mensaje',
      send: 'Enviar',
      accept_pay: 'Aceptar y Pagar',
      status: 'Estado',
      pending: 'Pendiente',
      confirmed: 'Confirmado',
      cancelled: 'Cancelado',
      history: 'Historial de Contrataciones',
    },
    support: {
      title: 'Soporte',
      placeholder: 'Escribe tu mensaje...',
      send: 'Enviar',
      faq: 'Preguntas Frecuentes',
    },
    dashboard: {
      title: 'Panel de Gestion',
      artists: 'Artistas',
      events: 'Eventos',
      songs: 'Canciones',
      users: 'Usuarios',
      bookings: 'Contrataciones',
      settings: 'Configuracion',
      analytics: 'Analiticas',
      api_keys: 'API Keys',
      invite: 'Invitar Usuario',
      overview: 'Resumen',
    },
    analytics: {
      title: 'Analiticas',
      total_plays: 'Reproducciones Totales',
      total_likes: 'Corcheas Totales',
      top_artists: 'Top Artistas',
      top_songs: 'Top Canciones',
      export: 'Exportar',
      genre_dist: 'Distribucion por Genero',
    },
    auth: {
      login: 'Iniciar Sesion',
      register: 'Registrarse',
      email: 'Email',
      password: 'Contrasena',
      name: 'Nombre',
      logout: 'Cerrar Sesion',
      as_user: 'Como Usuario',
      as_artist: 'Como Artista',
    },
    universe: {
      kicker: 'El ecosistema',
      title_pre: 'Una plataforma. ',
      title_accent: 'Todo es musica.',
      discover_title: 'Descubrir',
      discover_desc: 'Artistas, canciones y catalogos. Tu nueva escena empieza aqui.',
      live_title: 'En vivo',
      live_desc: 'Salas en tiempo real. Mira, escucha y apoya artistas en directo.',
      events_title: 'Eventos',
      events_desc: 'Mapa, entradas y reservas. Encuentra lo que pasa cerca de ti.',
      producer_title: 'Pulse Producer',
      producer_desc: 'Estudio con IA. Crea musica real con tu co-productor PULSE.',
      corcheas_title: 'Corcheas',
      corcheas_desc: 'Tu moneda creativa. Cada cancion que publicas te regala corcheas. Usalas para producir mas, apoyar artistas, o desbloquear herramientas pro.',
    },
    onboarding: {
      step_of: 'Paso {step} de {total}',
      skip: 'Ya lo pillo',
      next: 'Siguiente',
      lets_go: 'Vamos',
      step1_title: 'Dile que quieres',
      step1_subtitle: 'PULSE es tu co-productor',
      step1_desc: 'Habla natural: "algo para conducir de noche", "tipo Rosalia pero mas oscuro", o sube una foto y PULSE creara musica desde la vibe. Tambien puedes hablar por el micro.',
      step2_title: 'PULSE produce',
      step2_subtitle: 'Musica real en segundos',
      step2_desc: 'Cuando PULSE entiende lo que buscas, produce tu track. Sin botones complicados — la conversacion es el estudio.',
      step3_title: 'Itera y publica',
      step3_subtitle: 'Ajusta hasta que suene perfecto',
      step3_desc: 'Pide cambios: "mas agresivo", "quita el piano", "sube la energia". Cuando te guste, publica y compartelo con el mundo.',
    },
    daw: {
      freq_hint_drums: 'Bajos ~20-250Hz',
      freq_hint_bass: 'Sub-bajos ~60-300Hz',
      freq_hint_melody: 'Medios ~300-3kHz',
      freq_hint_chords: 'Medios-altos ~500-5kHz',
      freq_hint_voz: 'Presencia ~1-6kHz',
      freq_hint_fx: 'Brillos ~4-16kHz',
      eq_filter_label: 'Filtro EQ por banda',
    },
    coming_soon: {
      title: 'Proximamente',
      subtitle: 'Estamos construyendo algo increible.',
      cta: 'Ir a Pulse Producer',
      discover_msg: 'El descubrimiento de artistas y catalogos esta en camino. Mientras tanto, explora el estudio.',
      live_msg: 'Las salas en vivo estaran disponibles pronto. Mientras tanto, crea musica en el estudio.',
      events_msg: 'El mapa de eventos se esta preparando. Mientras tanto, produce tu primer track.',
      playlists_msg: 'Las playlists colaborativas llegaran pronto. Mientras tanto, crea en el estudio.',
    },
    common: {
      search: 'Buscar',
      loading: 'Cargando...',
      error: 'Error',
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      create: 'Crear',
      close: 'Cerrar',
      back: 'Volver',
      language: 'Idioma',
    }
  },
  en: {
    nav: { feed: 'Discover', map: 'Map', playlists: 'Playlists', support: 'Support', profile: 'Profile' },
    home: {
      hero_title: 'Music first, scene next',
      hero_subtitle: 'Discover artists, save favorites, follow events and book only when it makes sense',
      cta: 'View profile',
      trending: 'Trending',
      top_local: 'Top Local',
      for_you: 'For You',
      featured_artists: 'Featured Artists',
      upcoming_events: 'Upcoming Events',
      discover: 'Discover',
      view_all: 'View All',
      likes: 'Corcheas',
      plays: 'Plays',
      available: 'Available',
      not_available: 'Not Available',
    },
    artist: {
      per_show: '/ Show',
      upcoming: 'Upcoming Events',
      songs: 'Songs',
      similar: 'Similar Artists',
      hire: 'Hire',
      followers: 'Fans',
      reviews: 'Reviews',
    },
    events: {
      title: 'Event Map',
      filter_genre: 'Genre',
      filter_city: 'City',
      filter_date: 'Date',
      view_artists: 'View Artists',
      view_today: 'View Events Today',
      capacity: 'Capacity',
      price: 'Price',
    },
    player: {
      queue: 'Play Queue',
      history: 'History',
      shuffle: 'Shuffle',
      repeat: 'Repeat',
      now_playing: 'Now Playing',
    },
    playlist: {
      title: 'My Playlists',
      create: 'Create Playlist',
      add_song: 'Add Song',
      empty: 'No songs yet',
      public: 'Public',
      private: 'Private',
      name: 'Name',
      description: 'Description',
    },
    booking: {
      title: 'Booking',
      event_type: 'Event Type',
      date: 'Date',
      location: 'Location',
      message: 'Message',
      send: 'Send',
      accept_pay: 'Accept & Pay',
      status: 'Status',
      pending: 'Pending',
      confirmed: 'Confirmed',
      cancelled: 'Cancelled',
      history: 'Booking History',
    },
    support: {
      title: 'Support',
      placeholder: 'Write your message...',
      send: 'Send',
      faq: 'FAQ',
    },
    dashboard: {
      title: 'Management Panel',
      artists: 'Artists',
      events: 'Events',
      songs: 'Songs',
      users: 'Users',
      bookings: 'Bookings',
      settings: 'Settings',
      analytics: 'Analytics',
      api_keys: 'API Keys',
      invite: 'Invite User',
      overview: 'Overview',
    },
    analytics: {
      title: 'Analytics',
      total_plays: 'Total Plays',
      total_likes: 'Total Corcheas',
      top_artists: 'Top Artists',
      top_songs: 'Top Songs',
      export: 'Export',
      genre_dist: 'Genre Distribution',
    },
    auth: {
      login: 'Login',
      register: 'Register',
      email: 'Email',
      password: 'Password',
      name: 'Name',
      logout: 'Logout',
      as_user: 'As User',
      as_artist: 'As Artist',
    },
    universe: {
      kicker: 'The ecosystem',
      title_pre: 'One platform. ',
      title_accent: 'Everything music.',
      discover_title: 'Discover',
      discover_desc: 'Artists, songs & catalogs. Your new scene starts here.',
      live_title: 'Live',
      live_desc: 'Real-time rooms. Watch, listen & tip artists live.',
      events_title: 'Events',
      events_desc: 'Map, tickets & bookings. Find what\'s happening near you.',
      producer_title: 'Pulse Producer',
      producer_desc: 'AI-powered studio. Create real music with your co-producer PULSE.',
      corcheas_title: 'Corcheas',
      corcheas_desc: 'Your creative currency. Every song you publish earns corcheas. Use them to produce more, support artists, or unlock pro tools.',
    },
    onboarding: {
      step_of: 'Step {step} of {total}',
      skip: 'Got it',
      next: 'Next',
      lets_go: "Let's go",
      step1_title: 'Tell PULSE what you want',
      step1_subtitle: 'PULSE is your co-producer',
      step1_desc: 'Speak naturally: "something for driving at night", "like Rosalia but darker", or upload a photo and PULSE will create music from the vibe. You can also use the mic.',
      step2_title: 'PULSE produces',
      step2_subtitle: 'Real music in seconds',
      step2_desc: 'When PULSE understands your vision, it produces your track. No complicated buttons — the conversation IS the studio.',
      step3_title: 'Iterate and publish',
      step3_subtitle: 'Tweak until it sounds perfect',
      step3_desc: 'Ask for changes: "more aggressive", "remove the piano", "boost the energy". When you love it, publish and share it with the world.',
    },
    daw: {
      freq_hint_drums: 'Lows ~20-250Hz',
      freq_hint_bass: 'Sub-bass ~60-300Hz',
      freq_hint_melody: 'Mids ~300-3kHz',
      freq_hint_chords: 'Mid-highs ~500-5kHz',
      freq_hint_voz: 'Presence ~1-6kHz',
      freq_hint_fx: 'Air ~4-16kHz',
      eq_filter_label: 'EQ band filter',
    },
    coming_soon: {
      title: 'Coming Soon',
      subtitle: 'We\'re building something incredible.',
      cta: 'Go to Pulse Producer',
      discover_msg: 'Artist and catalog discovery is on its way. Meanwhile, explore the studio.',
      live_msg: 'Live rooms will be available soon. Meanwhile, create music in the studio.',
      events_msg: 'The events map is being prepared. Meanwhile, produce your first track.',
      playlists_msg: 'Collaborative playlists are coming soon. Meanwhile, create in the studio.',
    },
    common: {
      search: 'Search',
      loading: 'Loading...',
      error: 'Error',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      close: 'Close',
      back: 'Back',
      language: 'Language',
    }
  }
};
